export const ASSIGNMENT_MIXPANEL_EVENTS = {
  viewed: {
    learningPath: `Viewed Learning Path`,
    adl: `Viewed Daily Routine Activity`,
    structuredActivity: `Viewed Structured Activity`,
    customStructuredActivity: `Viewed Custom Structured Activity`,
  },
  completed: 'Completed Assignment',
  viewedPreview: {
    learningPath: `Viewed Learning Path Preview`,
    adl: `Viewed Daily Routine Activity Preview`,
    structuredActivity: `Viewed Structured Activity Preview`,
    customStructuredActivity: `Viewed Custom Structured Activity Preview`,
  },
};
